const errorMessages = {
    generalError: 'Something went wrong. Please try again or contact our support team the system administrators',
    SOMETHING_WRONG: 'Something went wrong. Please try again or contact our support team the system administrators',
    NETWORK_ERROR: 'NETWORK ERROR',
  };
  
  export default errorMessages;
  